import {LocationData} from '../types';

export const locationData: LocationData = {
        "countries": [
            {
                "id": "IR",
                "name": "Iran",
                "name_native": "ایران",
                "provinces": [
                    {
                        "id": "IR-01",
                        "name": "Tehran",
                        "name_native": "تهران",
                        "cities": [
                            {"id": "IR-01-0101", "name": "Tehran", "name_native": "تهران"},
                            {"id": "IR-01-0102", "name": "Rey", "name_native": "شهر ری"},
                            {"id": "IR-01-0103", "name": "Shemiranat", "name_native": "شمیرانات"},
                            {"id": "IR-01-0104", "name": "EslamShahr", "name_native": "اسلام‌شهر"},
                            {"id": "IR-01-0105", "name": "Baharestan", "name_native": "بهارستان"},
                            {"id": "IR-01-0106", "name": "Ghods", "name_native": "قدس"},
                            {"id": "IR-01-0107", "name": "RobatKarim", "name_native": "رباط‌کریم"},
                            {"id": "IR-01-0108", "name": "Shahriyar", "name_native": "شهریار"},
                            {"id": "IR-01-0109", "name": "Malard", "name_native": "ملارد"},
                            {"id": "IR-01-0110", "name": "Damavand", "name_native": "دماوند"},
                            {"id": "IR-01-0111", "name": "Pardis", "name_native": "پردیس"},
                            {"id": "IR-01-0112", "name": "FirouzKouh", "name_native": "فیروزکوه"}
                        ],
                    },
                    {
                        "id": "IR-02",
                        "name": "Gilan",
                        "name_native": "گیلان",
                        "cities": [
                            {"id": "IR-02-0201", "name": "Rasht", "name_native": "رشت"},
                            {"id": "IR-02-0202", "name": "BandarAnzali", "name_native": "بندر انزلی"},
                            {"id": "IR-02-0203", "name": "AstanehAshrafieh", "name_native": "آستانه‌اشرفیه"},
                            {"id": "IR-02-0204", "name": "Astara", "name_native": "آستارا"},
                            {"id": "IR-02-0205", "name": "Amlash", "name_native": "املش"},
                            {"id": "IR-02-0206", "name": "Roudbar", "name_native": "رودبار"},
                            {"id": "IR-02-0207", "name": "Roudsar", "name_native": "رودسر"},
                            {"id": "IR-02-0208", "name": "Siyahkal", "name_native": "سیاهکل"},
                            {"id": "IR-02-0209", "name": "Shaft", "name_native": "شفت"},
                            {"id": "IR-02-0210", "name": "SomeehSara", "name_native": "صومعه‌سرا"},
                            {"id": "IR-02-0211", "name": "Fouman", "name_native": "فومن"},
                            {"id": "IR-02-0212", "name": "Lahijan", "name_native": "لاهیجان"},
                            {"id": "IR-02-0213", "name": "Langroud", "name_native": "لنگرود"},
                            {"id": "IR-02-0214", "name": "Masal", "name_native": "ماسال"},
                            {"id": "IR-02-0215", "name": "RezvanShahr", "name_native": "رضوان‌شهر"},
                            {"id": "IR-02-0216", "name": "Talesh", "name_native": "تالش"},
                            {"id": "IR-02-0217", "name": "Khomam", "name_native": "خمام"}
                        ],
                    },
                    {
                        "id": "IR-03",
                        "name": "East Azarbaijan",
                        "name_native": "آذربایجان شرقی",
                        "cities": [
                            {"id": "IR-03-0301", "name": "Tabriz", "name_native": "تبریز"},
                            {"id": "IR-03-0302", "name": "Oskou", "name_native": "اسکو"},
                            {"id": "IR-03-0303", "name": "Ahar", "name_native": "اهر"},
                            {"id": "IR-03-0304", "name": "BostanAbad", "name_native": "بستان‌آباد"},
                            {"id": "IR-03-0305", "name": "Bonab", "name_native": "بناب"},
                            {"id": "IR-03-0306", "name": "Jolfa", "name_native": "جلفا"},
                            {"id": "IR-03-0307", "name": "CharOymagh", "name_native": "چاراویماق"},
                            {"id": "IR-03-0308", "name": "Sarab", "name_native": "سراب"},
                            {"id": "IR-03-0309", "name": "Shabestar", "name_native": "شبستر"},
                            {"id": "IR-03-0310", "name": "Ajabshir", "name_native": "عجب‌شیر"},
                            {"id": "IR-03-0311", "name": "Kalibar", "name_native": "کلیبر"},
                            {"id": "IR-03-0312", "name": "Maragheh", "name_native": "مراغه"},
                            {"id": "IR-03-0313", "name": "Marand", "name_native": "مرند"},
                            {"id": "IR-03-0314", "name": "Malekan", "name_native": "ملکان"},
                            {"id": "IR-03-0315", "name": "Miyaneh", "name_native": "میانه"},
                            {"id": "IR-03-0316", "name": "Varzaghan", "name_native": "ورزقان"},
                            {"id": "IR-03-0317", "name": "Haris", "name_native": "هریس"},
                            {"id": "IR-03-0318", "name": "Hashtroud", "name_native": "هشترود"},
                            {"id": "IR-03-0319", "name": "KhodaAfarin", "name_native": "خداآفرین"},
                            {"id": "IR-03-0320", "name": "AzarShahr", "name_native": "آذرشهر"}
                        ],
                    },
                    {
                        "id": "IR-04",
                        "name": "West Azarbaijan",
                        "name_native": "آذربایجان غربی",
                        "cities": [
                            {"id": "IR-04-0401", "name": "Urmia", "name_native": "ارومیه"},
                            {"id": "IR-04-0402", "name": "Boukan", "name_native": "بوکان"},
                            {"id": "IR-04-0403", "name": "PolDasht", "name_native": "پلدشت"},
                            {"id": "IR-04-0404", "name": "PiranShahr", "name_native": "پیرانشهر"},
                            {"id": "IR-04-0405", "name": "Takab", "name_native": "تکاب"},
                            {"id": "IR-04-0406", "name": "Chaldoran", "name_native": "چالدران"},
                            {"id": "IR-04-0407", "name": "Chaypareh", "name_native": "چایپاره"},
                            {"id": "IR-04-0408", "name": "Oshnavieh", "name_native": "اشنویه"},
                            {"id": "IR-04-0409", "name": "Khoy", "name_native": "خوی"},
                            {"id": "IR-04-0410", "name": "SaeDasht", "name_native": "سردشت"},
                            {"id": "IR-04-0411", "name": "Salmas", "name_native": "سلماس"},
                            {"id": "IR-04-0412", "name": "Shahindezh", "name_native": "شاهین‌دژ"},
                            {"id": "IR-04-0413", "name": "Makou", "name_native": "ماکو"},
                            {"id": "IR-04-0414", "name": "Mahabad", "name_native": "مهاباد"},
                            {"id": "IR-04-0415", "name": "Miyandoab", "name_native": "میاندوآب"},
                            {"id": "IR-04-0416", "name": "Naghadeh", "name_native": "نقده"},
                            {"id": "IR-04-0417", "name": "Barough", "name_native": "باروق"}
                        ],
                    },
                    {
                        "id": "IR-05",
                        "name": "Ardabil",
                        "name_native": "اردبیل",
                        "cities": [
                            {"id": "IR-05-0501", "name": "Ardabil", "name_native": "اردبیل"},
                            {"id": "IR-05-0502", "name": "Astara", "name_native": "آستارا"},
                            {"id": "IR-05-0503", "name": "BilehSavar", "name_native": "بیله‌سوار"},
                            {"id": "IR-05-0504", "name": "ParsAbad", "name_native": "پارس‌آباد"},
                            {"id": "IR-05-0505", "name": "Khalkhal", "name_native": "خلخال"},
                            {"id": "IR-05-0506", "name": "Sarein", "name_native": "سرعین"},
                            {"id": "IR-05-0507", "name": "Kosar", "name_native": "کوثر"},
                            {"id": "IR-05-0508", "name": "MeshkinShahr", "name_native": "مشگین‌شهر"},
                            {"id": "IR-05-0509", "name": "Namin", "name_native": "نمین"},
                            {"id": "IR-05-0510", "name": "nir", "name_native": "نیر"}
                        ],
                    },
                    {
                        "id": "IR-06",
                        "name": "Esfehan",
                        "cities": [
                            {"id": "IR-06-0601", "name": "Esfehan", "name_native": "اصفهان"},
                            {"id": "IR-06-0602", "name": "AranoBidgol", "name_native": "آران و بیدگل"},
                            {"id": "IR-06-0603", "name": "Abrisham", "name_native": "ابریشم"},
                            {"id": "IR-06-0604", "name": "Barkhar", "name_native": "برخوار"},
                            {"id": "IR-06-0605", "name": "BehAbad", "name_native": "به‌آباد"},
                            {"id": "IR-06-0606", "name": "TiranoKaroun", "name_native": "تیران و کرون"},
                            {"id": "IR-06-0607", "name": "Chadegan", "name_native": "چادگان"},
                            {"id": "IR-06-0608", "name": "khomeyniShahr", "name_native": "خمینی‌شهر"},
                            {"id": "IR-06-0609", "name": "Khansar", "name_native": "خوانسار"},
                            {"id": "IR-06-0610", "name": "Dehaghan", "name_native": "دهق"},
                            {"id": "IR-06-0611", "name": "Semirom", "name_native": "سمیرم"},
                            {"id": "IR-06-0612", "name": "ShahinShahr", "name_native": "شاهین‌شهر"},
                            {"id": "IR-06-0613", "name": "Kashan", "name_native": "کاشان"},
                            {"id": "IR-06-0614", "name": "Golpayegan", "name_native": "گلپایگان"},
                            {"id": "IR-06-0615", "name": "Lenjan", "name_native": "لنجان"},
                            {"id": "IR-06-0616", "name": "Mobarakeh", "name_native": "مبارکه"},
                            {"id": "IR-06-0617", "name": "Naein", "name_native": "نائین"},
                            {"id": "IR-06-0618", "name": "NajafAbad", "name_native": "نجف‌آباد"},
                            {"id": "IR-06-0619", "name": "Natanz", "name_native": "نطنز"},
                            {"id": "IR-06-0620", "name": "Kamijan", "name_native": "کمیجان"},
                            {"id": "IR-06-0621", "name": "FereydounShahr", "name_native": "فریدون‌شهر"},
                            {"id": "IR-06-0622", "name": "Falavarjan", "name_native": "فلاورجان"},
                            {"id": "IR-06-0623", "name": "Kashan", "name_native": "کاشان"},
                            {"id": "IR-06-0624", "name": "KhouroBiyabanek", "name_native": "خور و بیابانک"}
                        ],
                        "name_native": "اصفهان"
                    },
                    {
                        "id": "IR-07",
                        "name": "Sistan and Baluchestan",
                        "cities": [
                            {"id": "IR-07-0701", "name": "Zahedan", "name_native": "زاهدان"},
                            {"id": "IR-07-0702", "name": "Zabol", "name_native": "زابل"},
                            {"id": "IR-07-0703", "name": "Zahak", "name_native": "زهک"},
                            {"id": "IR-07-0704", "name": "Hirmand", "name_native": "هیرمند"},
                            {"id": "IR-07-0705", "name": "Nimruz", "name_native": "نیمروز"},
                            {"id": "IR-07-0706", "name": "Khash", "name_native": "خاش"},
                            {"id": "IR-07-0707", "name": "Mirjaveh", "name_native": "میرجاوه"},
                            {"id": "IR-07-0708", "name": "Saravan", "name_native": "سراوان"},
                            {"id": "IR-07-0709", "name": "SibSuran", "name_native": "سیب و سوران"},
                            {"id": "IR-07-0710", "name": "Mehrestan", "name_native": "مهرستان"},
                            {"id": "IR-07-0711", "name": "Sarbaz", "name_native": "سرباز"},
                            {"id": "IR-07-0712", "name": "Qasr-e-Qand", "name_native": "قصرقند"},
                            {"id": "IR-07-0713", "name": "Fanuj", "name_native": "فنوج"},
                            {"id": "IR-07-0714", "name": "Nikshahr", "name_native": "نیک‌شهر"},
                            {"id": "IR-07-0715", "name": "Konarak", "name_native": "کنارک"},
                            {"id": "IR-07-0716", "name": "Chabahar", "name_native": "چابهار"},
                            {"id": "IR-07-0717", "name": "Delgan", "name_native": "دلگان"},
                            {"id": "IR-07-0718", "name": "Bampour", "name_native": "بامپور"},
                            {"id": "IR-07-0719", "name": "Iranshahr", "name_native": "ایران‌شهر"}
                        ],
                        "name_native": "سیستان و بلوچستان"
                    },
                    {
                        "id": "IR-08",
                        "name": "Ilam",
                        "cities": [
                            {"id": "IR-08-0801", "name": "Ilam", "name_native": "ایلام"},
                            {"id": "IR-08-0802", "name": "Abdanan", "name_native": "آبدانان"},
                            {"id": "IR-08-0803", "name": "Chardaval", "name_native": "چرداول"},
                            {"id": "IR-08-0804", "name": "DarehShahr", "name_native": "دره‌شهر"},
                            {"id": "IR-08-0805", "name": "Dalahou", "name_native": "دهلران"},
                            {"id": "IR-08-0806", "name": "Ehloran", "name_native": "ایوان"},
                            {"id": "IR-08-0807", "name": "Mehran", "name_native": "مهران"},
                            {"id": "IR-08-0808", "name": "Malekshahi", "name_native": "ملکشاهی"},
                            {"id": "IR-08-0809", "name": "Halilan", "name_native": "هلیلان"}
                        ],
                        "name_native": "ایلام"
                    },
                    {
                        "id": "IR-09",
                        "name": "Bushehr",
                        "cities": [
                            {"id": "IR-09-0901", "name": "Bushehr", "name_native": "بوشهر"},
                            {"id": "IR-09-0902", "name": "Dashtestan", "name_native": "دشتستان"},
                            {"id": "IR-09-0903", "name": "Deyr", "name_native": "دیر"},
                            {"id": "IR-09-0904", "name": "Tangestan", "name_native": "تنگستان"},
                            {"id": "IR-09-0905", "name": "Genaveh", "name_native": "گناوه"},
                            {"id": "IR-09-0906", "name": "Kangan", "name_native": "کنگان"},
                            {"id": "IR-09-0907", "name": "Borazjan", "name_native": "برازجان"},
                            {"id": "IR-09-0908", "name": "Jam", "name_native": "جم"},
                            {"id": "IR-09-0909", "name": "Alangouieh", "name_native": "انگویه"}
                        ],
                        "name_native": "بوشهر"
                    },
                    {
                        "id": "IR-10",
                        "name": "Chahar Mahall and Bakhtiari",
                        "cities": [
                            {"id": "IR-10-1001", "name": "ShahrKord", "name_native": "شهرکرد"},
                            {"id": "IR-10-1002", "name": "Saman", "name_native": "سامان"},
                            {"id": "IR-10-1003", "name": "Farsan", "name_native": "فارسان"},
                            {"id": "IR-10-1004", "name": "Lordegan", "name_native": "لردگان"},
                            {"id": "IR-10-1005", "name": "Kouhrang", "name_native": "کوهرنگ"},
                            {"id": "IR-10-1006", "name": "bon", "name_native": "بن"},
                            {"id": "IR-10-1007", "name": "Kiyar", "name_native": "کیار"},
                            {"id": "IR-10-1008", "name": "Ardal", "name_native": "اردل"}
                        ],
                        "name_native": "چهارمحال و بختیاری"
                    },
                    {
                        "id": "IR-11",
                        "name": "South Khorasan",
                        "cities": [
                            {"id": "IR-11-1101", "name": "Birjand", "name_native": "بیرجند"},
                            {"id": "IR-11-1102", "name": "Nahbandan", "name_native": "نهبندان"},
                            {"id": "IR-11-1103", "name": "Ghayenat", "name_native": "قائنات"},
                            {"id": "IR-11-1104", "name": "Ferdos", "name_native": "فردوس"},
                            {"id": "IR-11-1105", "name": "Sarbisheh", "name_native": "سربیشه"},
                            {"id": "IR-11-1106", "name": "Tabas", "name_native": "طبس"},
                            {"id": "IR-11-1107", "name": "Dohovak", "name_native": "دهوک"},
                            {"id": "IR-11-1108", "name": "Khousef", "name_native": "خوسف"},
                            {"id": "IR-11-1109", "name": "Sarayan", "name_native": "سرایان"},
                            {"id": "IR-11-1110", "name": "Darmiyan", "name_native": "درمیان"},
                            {"id": "IR-11-1111", "name": "Shousef", "name_native": "شوسف"}
                        ],
                        "name_native": "خراسان جنوبی"
                    },
                    {
                        "id": "IR-12",
                        "name": "Razavi Khorasan",
                        "cities": [
                            {"id": "IR-12-1201", "name": "Mashahd", "name_native": "مشهد"},
                            {"id": "IR-12-1202", "name": "Sabzevar", "name_native": "سبزوار"},
                            {"id": "IR-12-1203", "name": "Taybad", "name_native": "تایباد"},
                            {"id": "IR-12-1204", "name": "Khaf", "name_native": "خواف"},
                            {"id": "IR-12-1205", "name": "Kashmar", "name_native": "کاشمر"},
                            {"id": "IR-12-1206", "name": "Genabad", "name_native": "گناباد"},
                            {"id": "IR-12-1207", "name": "TorghabhoShandiz", "name_native": "طرقبه و شاندیز"},
                            {"id": "IR-12-1208", "name": "Neyshbour", "name_native": "نیشابور"},
                            {"id": "IR-12-1209", "name": "Bardeskan", "name_native": "بردسکن"},
                            {"id": "IR-12-1210", "name": "Chenaran", "name_native": "چناران"},
                            {"id": "IR-12-1211", "name": "Fariman", "name_native": "فریمان"},
                            {"id": "IR-12-1212", "name": "TorbatJam", "name_native": "تربت‌جام"},
                            {"id": "IR-12-1213", "name": "TorbatHeydarieh", "name_native": "تربت‌حیدریه"},
                            {"id": "IR-12-1214", "name": "Kalat", "name_native": "کلات"},
                            {"id": "IR-12-1215", "name": "Dargez", "name_native": "درگز"},
                            {"id": "IR-12-1216", "name": "Rashtkhar", "name_native": "رشتخوار"},
                            {"id": "IR-12-1217", "name": "Ghouchan", "name_native": "قوچان"},
                            {"id": "IR-12-1218", "name": "KhalilAbad", "name_native": "خلیل‌آباد"},
                            {"id": "IR-12-1219", "name": "Kouhsorkh", "name_native": "کوهسرخ"},
                            {"id": "IR-12-1220", "name": "Bejestan", "name_native": "بجستان"},
                            {"id": "IR-12-1221", "name": "Sarakhs", "name_native": "سرخس"},
                            {"id": "IR-12-1222", "name": "Bakhraz", "name_native": "باخرز"},
                            {"id": "IR-12-1223", "name": "Joghtay", "name_native": "جغتای"},
                            {"id": "IR-12-1224", "name": "Jovin", "name_native": "جوین"},
                            {"id": "IR-12-1225", "name": "Khoushab", "name_native": "خوشاب"},
                            {"id": "IR-12-1226", "name": "Davarzan", "name_native": "داورزن"},
                            {"id": "IR-12-1227", "name": "Zaveh", "name_native": "زاوه"},
                            {"id": "IR-12-1228", "name": "Zabarkhan", "name_native": "زبرخان"},
                            {"id": "IR-12-1229", "name": "Sabzevar", "name_native": "سبزوار"},
                            {"id": "IR-12-1230", "name": "Shoshtamed", "name_native": "ششتمد"},
                            {"id": "IR-12-1231", "name": "SalehAbad", "name_native": "صالح‌آباد"},
                            {"id": "IR-12-1232", "name": "Golbahar", "name_native": "گلبهار"},
                            {"id": "IR-12-1233", "name": "MiyanJolgeh", "name_native": "میان‌جلگه"},
                            {"id": "IR-12-1234", "name": "MahoLat", "name_native": "ماه‌ولات"}
                        ],
                        "name_native": "خراسان رضوی"
                    },
                    {
                        "id": "IR-13",
                        "name": "North Khorasan",
                        "cities": [
                            {"id": "IR-13-1301", "name": "Esfarayen", "name_native": "اسفراین"},
                            {"id": "IR-13-1302", "name": "Bojnord", "name_native": "بجنورد"},
                            {"id": "IR-13-1303", "name": "Jajarm", "name_native": "جاجرم"},
                            {"id": "IR-13-1304", "name": "RazoJorgalan", "name_native": "راز و جرگلان"},
                            {"id": "IR-13-1305", "name": "Shirvan", "name_native": "شیروان"},
                            {"id": "IR-13-1306", "name": "Farouj", "name_native": "فاروج"},
                            {"id": "IR-13-1307", "name": "Garmeh", "name_native": "گرمه"},
                            {"id": "IR-13-1308", "name": "Samleghan", "name_native": "سملقان"},
                            {"id": "IR-13-1309", "name": "Maneh", "name_native": "مانه"}
                        ],
                        "name_native": "خراسان شمالی"
                    },
                    {
                        "id": "IR-14",
                        "name": "Khuzestan",
                        "cities": [
                            {"id": "IR-14-1401", "name": "Ahvaz", "name_native": "اهواز"},
                            {"id": "IR-14-1402", "name": "Dezfoul", "name_native": "دزفول"},
                            {"id": "IR-14-1403", "name": "Eizeh", "name_native": "ایذه"},
                            {"id": "IR-14-1404", "name": "Shoush", "name_native": "شوش"},
                            {"id": "IR-14-1405", "name": "Shadegan", "name_native": "شادگان"},
                            {"id": "IR-14-1406", "name": "Andimeshk", "name_native": "اندیمشک"},
                            {"id": "IR-14-1407", "name": "Behbahan", "name_native": "بهبهان"},
                            {"id": "IR-14-1408", "name": "Hoveyzeh", "name_native": "هویزه"},
                            {"id": "IR-14-1409", "name": "Abadan", "name_native": "آبادان"},
                            {"id": "IR-14-1410", "name": "Shoushtar", "name_native": "شوشتر"},
                            {"id": "IR-14-1411", "name": "Andika", "name_native": "اندیکا"},
                            {"id": "IR-14-1412", "name": "Omidiyeh", "name_native": "امیدیه"},
                            {"id": "IR-14-1413", "name": "Khoramshahr", "name_native": "خرمشهر"},
                            {"id": "IR-14-1414", "name": "Baghmalek", "name_native": "باغ‌ملک"},
                            {"id": "IR-14-1415", "name": "MasjedSoleyman", "name_native": "مسجدسلیمان"},
                            {"id": "IR-14-1416", "name": "DashtAzadegan", "name_native": "دشت آزادگان"},
                            {"id": "IR-14-1417", "name": "Mahshahr", "name_native": "ماهشهر"},
                            {"id": "IR-14-1418", "name": "Ramhormoz", "name_native": "رامهرمز"},
                            {"id": "IR-14-1419", "name": "Ramshir", "name_native": "رامشیر"},
                            {"id": "IR-14-1420", "name": "Haftgol", "name_native": "هفتگل"},
                            {"id": "IR-14-1421", "name": "lali", "name_native": "لالی"},
                            {"id": "IR-14-1422", "name": "Bavi", "name_native": "باوی"},
                            {"id": "IR-14-1423", "name": "Gotvand", "name_native": "گتوند"}
                        ],
                        "name_native": "خوزستان"
                    },
                    {
                        "id": "IR-15",
                        "name": "Zanjan",
                        "cities": [
                            {"id": "IR-15-1501", "name": "Zanjan", "name_native": "زنجان"},
                            {"id": "IR-15-1502", "name": "Abhar", "name_native": "ابهر"},
                            {"id": "IR-15-1503", "name": "Khodabandeh", "name_native": "خدابنده"},
                            {"id": "IR-15-1504", "name": "Khoramdareh", "name_native": "خرمدره"},
                            {"id": "IR-15-1505", "name": "Tarom", "name_native": "طارم"},
                            {"id": "IR-15-1506", "name": "mahanshan", "name_native": "ماه‌نشان"},
                            {"id": "IR-15-1507", "name": "Eijroud", "name_native": "ایجرود"},
                            {"id": "IR-15-1508", "name": "Soltaniyeh", "name_native": "سلطانیه"}
                        ],
                        "name_native": "زنجان"
                    },
                    {
                        "id": "IR-16",
                        "name": "Semnan",
                        "cities": [
                            {"id": "IR-16-1601", "name": "Semnan", "name_native": "سمنان"},
                            {"id": "IR-16-1602", "name": "Shahroud", "name_native": "شاهرود"},
                            {"id": "IR-16-1603", "name": "Damghan", "name_native": "دامغان"},
                            {"id": "IR-16-1604", "name": "Garmsar", "name_native": "گرمسار"},
                            {"id": "IR-16-1605", "name": "MahdiShahr", "name_native": "مهدی‌شهر"},
                            {"id": "IR-16-1606", "name": "Sorkheh", "name_native": "سرخه"},
                            {"id": "IR-16-1607", "name": "Miami", "name_native": "میامی"},
                            {"id": "IR-16-1608", "name": "Aradan", "name_native": "آرادان"}
                        ],
                        "name_native": "سمنان"
                    },
                    {
                        "id": "IR-17",
                        "name": "alborz",
                        "cities": [
                            {"id": "IR-17-1701", "name": "Karaj", "name_native": "کرج"},
                            {"id": "IR-17-1702", "name": "Taleghan", "name_native": "طالقان"},
                            {"id": "IR-17-1703", "name": "Savojbolagh", "name_native": "ساوجبلاغ"},
                            {"id": "IR-17-1704", "name": "Nazarabad", "name_native": "نظرآباد"},
                            {"id": "IR-17-1705", "name": "Eshtehard", "name_native": "اشتهارد"},
                            {"id": "IR-17-1706", "name": "Fardis", "name_native": "فردیس"}
                        ],
                        "name_native": "البرز"
                    },
                    {
                        "id": "IR-18",
                        "name": "Fars",
                        "cities": [
                            {"id": "IR-18-1801", "name": "Shraz", "name_native": "شیراز"},
                            {"id": "IR-18-1802", "name": "Abadeh", "name_native": "آباده"},
                            {"id": "IR-18-1803", "name": "Arsanjan", "name_native": "ارسنجان"},
                            {"id": "IR-18-1804", "name": "Estahban", "name_native": "استهبان"},
                            {"id": "IR-18-1805", "name": "Eghlid", "name_native": "اقلید"},
                            {"id": "IR-18-1806", "name": "Avaz", "name_native": "اوز"},
                            {"id": "IR-18-1807", "name": "Bakhtagan", "name_native": "بختگان"},
                            {"id": "IR-18-1808", "name": "Bavanat", "name_native": "بوانات"},
                            {"id": "IR-18-1809", "name": "Beyza", "name_native": "بیضا"},
                            {"id": "IR-18-1810", "name": "Pasargad", "name_native": "پاسارگاد"},
                            {"id": "IR-18-1811", "name": "Jovim", "name_native": "جویم"},
                            {"id": "IR-18-1812", "name": "Jahrom", "name_native": "جهرم"},
                            {"id": "IR-18-1813", "name": "Khorameh", "name_native": "خرامه"},
                            {"id": "IR-18-1814", "name": "Khrambid", "name_native": "خرم‌بید"},
                            {"id": "IR-18-1815", "name": "Khafar", "name_native": "خفر"},
                            {"id": "IR-18-1816", "name": "Khenj", "name_native": "خنج"},
                            {"id": "IR-18-1817", "name": "Darab", "name_native": "داراب"},
                            {"id": "IR-18-1818", "name": "Rostam", "name_native": "رستم"},
                            {"id": "IR-18-1819", "name": "Zarghan", "name_native": "زرقان"},
                            {"id": "IR-18-1820", "name": "ZarinDasht", "name_native": "زرین‌دشت"},
                            {"id": "IR-18-1821", "name": "Sepidan", "name_native": "سپیدان"},
                            {"id": "IR-18-1822", "name": "Sarchehan", "name_native": "سرچهان"},
                            {"id": "IR-18-1823", "name": "Sarvestan", "name_native": "سروستان"},
                            {"id": "IR-18-1824", "name": "Farashband", "name_native": "فراشبند"},
                            {"id": "IR-18-1825", "name": "Fasa", "name_native": "فسا"},
                            {"id": "IR-18-1826", "name": "FirouzAbad", "name_native": "فیروزآباد"},
                            {"id": "IR-18-1827", "name": "GhiroKarin", "name_native": "قیروکارزین"},
                            {"id": "IR-18-1828", "name": "Kazeroun", "name_native": "کازرون"},
                            {"id": "IR-18-1829", "name": "Kovar", "name_native": "کوار"},
                            {"id": "IR-18-1830", "name": "KouhChenar", "name_native": "کوه‌چنار"},
                            {"id": "IR-18-1831", "name": "Garash", "name_native": "گراش"},
                            {"id": "IR-18-1832", "name": "Larestan", "name_native": "لارستان"},
                            {"id": "IR-18-1833", "name": "Lamard", "name_native": "لامرد"},
                            {"id": "IR-18-1834", "name": "Marvdasht", "name_native": "مرودشت"},
                            {"id": "IR-18-1835", "name": "Momasni", "name_native": "ممسنی"},
                            {"id": "IR-18-1836", "name": "Mohr", "name_native": "مهر"},
                            {"id": "IR-18-1837", "name": "Neyriz", "name_native": "نی‌ریز"}
                        ],
                        "name_native": "فارس"
                    },
                    {
                        "id": "IR-19",
                        "name": "qazvin",
                        "cities": [
                            {"id": "IR-19-1901", "name": "Qazvin", "name_native": "قزوین"},
                            {"id": "IR-19-1902", "name": "Alborz", "name_native": "البرز"},
                            {"id": "IR-19-1903", "name": "Abyek", "name_native": "آبیک"},
                            {"id": "IR-19-1904", "name": "BuinZahra", "name_native": "بوئین‌زهرا"},
                            {"id": "IR-19-1905", "name": "Takestan", "name_native": "تاکستان"},
                            {"id": "IR-19-1906", "name": "Avaj", "name_native": "آوج"}
                        ],
                        "name_native": "قزوین"
                    },
                    {
                        "id": "IR-20",
                        "name": "qom",
                        "cities": [
                            {"id": "IR-20-2001", "name": "Ghom", "name_native": "قم"},
                            {"id": "IR-20-2002", "name": "Kahak", "name_native": "کهک"},
                            {"id": "IR-20-2003", "name": "JafarAbad", "name_native": "جعفرآباد"}
                        ],
                        "name_native": "قم"
                    },
                    {
                        "id": "IR-21",
                        "name": "Kordestan",
                        "cities": [
                            {"id": "IR-21-2101", "name": "Sanandaj", "name_native": "سنندج"},
                            {"id": "IR-21-2102", "name": "Saghez", "name_native": "سقز"},
                            {"id": "IR-21-2103", "name": "Marivan", "name_native": "مریوان"},
                            {"id": "IR-21-2104", "name": "Baneh", "name_native": "بانه"},
                            {"id": "IR-21-2105", "name": "Ghorveh", "name_native": "قروه"},
                            {"id": "IR-21-2106", "name": "Kamyaran", "name_native": "کامیاران"},
                            {"id": "IR-21-2107", "name": "Bijar", "name_native": "بیجار"},
                            {"id": "IR-21-2108", "name": "Divandarreh", "name_native": "دیواندره"},
                            {"id": "IR-21-2109", "name": "Dehlegan", "name_native": "دهگلان"},
                            {"id": "IR-21-2110", "name": "SarvAbad", "name_native": "سروآباد"}
                        ],
                        "name_native": "کردستان"
                    },
                    {
                        "id": "IR-22",
                        "name": "Kerman",
                        "cities": [
                            {"id": "IR-22-2201", "name": "Kerman", "name_native": "کرمان"},
                            {"id": "IR-22-2202", "name": "Sirjan", "name_native": "سیرجان"},
                            {"id": "IR-22-2203", "name": "Rafsanjan", "name_native": "رفسنجان"},
                            {"id": "IR-22-2204", "name": "Jiroft", "name_native": "جیرفت"},
                            {"id": "IR-22-2205", "name": "Bam", "name_native": "بم"},
                            {"id": "IR-22-2206", "name": "Zarand", "name_native": "زرند"},
                            {"id": "IR-22-2207", "name": "ShahrBabak", "name_native": "شهربابک"},
                            {"id": "IR-22-2208", "name": "Kahnouj", "name_native": "کهنوج"},
                            {"id": "IR-22-2209", "name": "Baft", "name_native": "بافت"},
                            {"id": "IR-22-2210", "name": "AnbarAbad", "name_native": "عنبرآباد"},
                            {"id": "IR-22-2211", "name": "Bardsir", "name_native": "بردسیر"},
                            {"id": "IR-22-2212", "name": "GhaleeGanj", "name_native": "قلعه‌گنج"},
                            {"id": "IR-22-2213", "name": "Fahraj", "name_native": "فهرج"},
                            {"id": "IR-22-2214", "name": "Manoujan", "name_native": "منوجان"},
                            {"id": "IR-22-2215", "name": "Rigan", "name_native": "ریگان"},
                            {"id": "IR-22-2216", "name": "RoudbarJonoub", "name_native": "رودبار جنوب"},
                            {"id": "IR-22-2217", "name": "Narmashir", "name_native": "نرماشیر"},
                            {"id": "IR-22-2218", "name": "Jazmouriyan", "name_native": "جازموریان"},
                            {"id": "IR-22-2219", "name": "Ravar", "name_native": "راور"},
                            {"id": "IR-22-2220", "name": "Arzoueieh", "name_native": "ارزوئیه"},
                            {"id": "IR-22-2221", "name": "Anar", "name_native": "انار"},
                            {"id": "IR-22-2222", "name": "Rabar", "name_native": "رابر"},
                            {"id": "IR-22-2223", "name": "Faryab", "name_native": "فاریاب"},
                            {"id": "IR-22-2224", "name": "Gonbaki", "name_native": "گنبکی"},
                            {"id": "IR-22-2225", "name": "Kouhbanan", "name_native": "کوهبنان"}
                        ],
                        "name_native": "کرمان"
                    },
                    {
                        "id": "IR-23",
                        "name": "Kermanshah",
                        "cities": [
                            {"id": "IR-23-2301", "name": "Kermanshah", "name_native": "کرمانشاه"},
                            {"id": "IR-23-2302", "name": "EslamAbadGharb", "name_native": "اسلام‌آباد غرب"},
                            {"id": "IR-23-2303", "name": "Sarpolzahab", "name_native": "سرپل ذهاب"},
                            {"id": "IR-23-2304", "name": "Sanaghz", "name_native": "سنقر"},
                            {"id": "IR-23-2305", "name": "Harsin", "name_native": "هرسین"},
                            {"id": "IR-23-2306", "name": "Kangavar", "name_native": "کنگاور"},
                            {"id": "IR-23-2307", "name": "Javanroud", "name_native": "جوانرود"},
                            {"id": "IR-23-2308", "name": "Sahneh", "name_native": "صحنه"},
                            {"id": "IR-23-2309", "name": "Paveh", "name_native": "پاوه"},
                            {"id": "IR-23-2310", "name": "Gilangharb", "name_native": "گیلانغرب"},
                            {"id": "IR-23-2311", "name": "Ravansar", "name_native": "روانسر"},
                            {"id": "IR-23-2312", "name": "Dalahou", "name_native": "دالاهو"},
                            {"id": "IR-23-2313", "name": "Salasbabjani", "name_native": "ثلاث باباجانی"},
                            {"id": "IR-23-2314", "name": "GhasrShirin", "name_native": "قصرشیرین"}
                        ],
                        "name_native": "کرمانشاه"
                    },
                    {
                        "id": "IR-24",
                        "name": "Kohgiluyeh and Buyer Ahmad",
                        "cities": [
                            {"id": "IR-24-2401", "name": "Yassouj", "name_native": "یاسوج"},
                            {"id": "IR-24-2402", "name": "Dehdasht", "name_native": "دهدشت"},
                            {"id": "IR-24-2403", "name": "Gachsaran", "name_native": "گچساران"},
                            {"id": "IR-24-2404", "name": "Dena", "name_native": "دنا"},
                            {"id": "IR-24-2405", "name": "Bahmaeie", "name_native": "بهمئی"},
                            {"id": "IR-24-2406", "name": "Charam", "name_native": "چرام"},
                            {"id": "IR-24-2407", "name": "Basht", "name_native": "باشت"},
                            {"id": "IR-24-2408", "name": "Landeh", "name_native": "لنده"},
                            {"id": "IR-24-2409", "name": "Margoun", "name_native": "مارگون"}
                        ],
                        "name_native": "کهگیلویه و بویراحمد"
                    },
                    {
                        "id": "IR-25",
                        "name": "Golestan",
                        "cities": [
                            {"id": "IR-25-2501", "name": "BandarGez", "name_native": "بندر گز"},
                            {"id": "IR-25-2502", "name": "Torkaman", "name_native": "ترکمن"},
                            {"id": "IR-25-2503", "name": "Gamishan", "name_native": "گمیشان"},
                            {"id": "IR-25-2504", "name": "Kordkoy", "name_native": "کردکوی"},
                            {"id": "IR-25-2505", "name": "Gorgan", "name_native": "گرگان"},
                            {"id": "IR-25-2506", "name": "Aghghala", "name_native": "آق‌قلا"},
                            {"id": "IR-25-2507", "name": "AliAbad", "name_native": "علی‌آباد"},
                            {"id": "IR-25-2508", "name": "GonbadKavous", "name_native": "گنبد کاووس"},
                            {"id": "IR-25-2509", "name": "Ramiyan", "name_native": "رامیان"},
                            {"id": "IR-25-2510", "name": "AzadShahr", "name_native": "آزادشهر"},
                            {"id": "IR-25-2511", "name": "MinouDasht", "name_native": "مینودشت"},
                            {"id": "IR-25-2512", "name": "Galikesh", "name_native": "گالیکش"},
                            {"id": "IR-25-2513", "name": "Kalaleh", "name_native": "کلاله"},
                            {"id": "IR-25-2514", "name": "MaravehTappeh", "name_native": "مراوه‌تپه"}
                        ],
                        "name_native": "گلستان"
                    },
                    {
                        "id": "IR-26",
                        "name": "Lorestan",
                        "cities": [
                            {"id": "IR-26-2601", "name": "KhoramAbad", "name_native": "خرم‌آباد"},
                            {"id": "IR-26-2602", "name": "Borojerd", "name_native": "بروجرد"},
                            {"id": "IR-26-2603", "name": "Doroud", "name_native": "دورود"},
                            {"id": "IR-26-2604", "name": "KouhDasht", "name_native": "کوهدشت"},
                            {"id": "IR-26-2605", "name": "Delfan", "name_native": "دلفان"},
                            {"id": "IR-26-2606", "name": "Aligoudarz", "name_native": "الیگودرز"},
                            {"id": "IR-26-2607", "name": "Aleshtar", "name_native": "الشتر"},
                            {"id": "IR-26-2608", "name": "Azna", "name_native": "ازنا"},
                            {"id": "IR-26-2609", "name": "Poldokhtar", "name_native": "پلدختر"},
                            {"id": "IR-26-2610", "name": "Changi", "name_native": "چگنی"},
                            {"id": "IR-26-2611", "name": "Chaghabol", "name_native": "چقابل"}
                        ],
                        "name_native": "لرستان"
                    },
                    {
                        "id": "IR-27",
                        "name": "Mazandaran",
                        "cities": [
                            {"id": "IR-27-2701", "name": "Galougah", "name_native": "گلوگاه"},
                            {"id": "IR-27-2702", "name": "Behshahr", "name_native": "بهشهر"},
                            {"id": "IR-27-2703", "name": "Neka", "name_native": "نکا"},
                            {"id": "IR-27-2704", "name": "Miyandoab", "name_native": "میاندوآب"},
                            {"id": "IR-27-2705", "name": "Sari", "name_native": "ساری"},
                            {"id": "IR-27-2706", "name": "Joybar", "name_native": "جویبار"},
                            {"id": "IR-27-2707", "name": "Simorgh", "name_native": "سیمرغ"},
                            {"id": "IR-27-2708", "name": "GhaemShahr", "name_native": "قائم‌شهر"},
                            {"id": "IR-27-2709", "name": "Savadkouh", "name_native": "سوادکوه"},
                            {"id": "IR-27-2710", "name": "Babolsar", "name_native": "بابلسر"},
                            {"id": "IR-27-2711", "name": "Babol", "name_native": "بابل"},
                            {"id": "IR-27-2712", "name": "FereydounKenar", "name_native": "فریدون‌کنار"},
                            {"id": "IR-27-2713", "name": "MahmoudAbad", "name_native": "محمودآباد"},
                            {"id": "IR-27-2714", "name": "Amol", "name_native": "آمل"},
                            {"id": "IR-27-2715", "name": "Nour", "name_native": "نور"},
                            {"id": "IR-27-2716", "name": "Noshahr", "name_native": "نوشهر"},
                            {"id": "IR-27-2717", "name": "Chalous", "name_native": "چالوس"},
                            {"id": "IR-27-2718", "name": "Kelardasht", "name_native": "کلاردشت"},
                            {"id": "IR-27-2719", "name": "AbbasAbad", "name_native": "عباس‌آباد"},
                            {"id": "IR-27-2720", "name": "Tonkabon", "name_native": "تنکابن"},
                            {"id": "IR-27-2721", "name": "Ramsar", "name_native": "رامسر"}
                        ],
                        "name_native": "مازندران"
                    },
                    {
                        "id": "IR-28",
                        "name": "Markazi",
                        "cities": [
                            {"id": "IR-28-2801", "name": "Arak", "name_native": "اراک"},
                            {"id": "IR-28-2802", "name": "Ashtiyan", "name_native": "آشتیان"},
                            {"id": "IR-28-2803", "name": "Tafresh", "name_native": "تفرش"},
                            {"id": "IR-28-2804", "name": "Khomein", "name_native": "خمین"},
                            {"id": "IR-28-2805", "name": "Khandab", "name_native": "خنداب"},
                            {"id": "IR-28-2806", "name": "Delijan", "name_native": "دلیجان"},
                            {"id": "IR-28-2807", "name": "Saveh", "name_native": "ساوه"},
                            {"id": "IR-28-2808", "name": "Shazand", "name_native": "شازند"},
                            {"id": "IR-28-2809", "name": "Kamijan", "name_native": "کمیجان"},
                            {"id": "IR-28-2810", "name": "Mamouniyeh", "name_native": "مامونیه"},
                            {"id": "IR-28-2811", "name": "Mahallat", "name_native": "محلات"},
                            {"id": "IR-28-2812", "name": "Farmahin", "name_native": "فرمهین"}
                        ],
                        "name_native": "مرکزی"
                    },
                    {
                        "id": "IR-29",
                        "name": "Hormozgan",
                        "cities": [
                            {"id": "IR-29-2901", "name": "BandarAbbas", "name_native": "بندرعباس"},
                            {"id": "IR-29-2902", "name": "Minab", "name_native": "میناب"},
                            {"id": "IR-29-2903", "name": "BAndarLengeh", "name_native": "بندرلنگه"},
                            {"id": "IR-29-2904", "name": "Gheshm", "name_native": "قشم"},
                            {"id": "IR-29-2905", "name": "Roudan", "name_native": "رودان"},
                            {"id": "IR-29-2906", "name": "Bastak", "name_native": "بستک"},
                            {"id": "IR-29-2907", "name": "HajiAbad", "name_native": "حاجی‌آباد"},
                            {"id": "IR-29-2908", "name": "BandarJask", "name_native": "بندر جاسک"},
                            {"id": "IR-29-2909", "name": "BandarKhamir", "name_native": "بندر خمیر"},
                            {"id": "IR-29-2910", "name": "Parsiyan", "name_native": "پارسیان"},
                            {"id": "IR-29-2911", "name": "Sirik", "name_native": "سیریک"},
                            {"id": "IR-29-2912", "name": "Bashagerd", "name_native": "بشاگرد"},
                            {"id": "IR-29-2913", "name": "Aboumousa", "name_native": "ابوموسی"}
                        ],
                        "name_native": "هرمزگان"
                    },
                    {
                        "id": "IR-30",
                        "name": "Hamedan",
                        "cities": [
                            {"id": "IR-30-3001", "name": "Hamedan", "name_native": "همدان"},
                            {"id": "IR-30-3002", "name": "Malayer", "name_native": "ملایر"},
                            {"id": "IR-30-3003", "name": "Nahavand", "name_native": "نهاوند"},
                            {"id": "IR-30-3004", "name": "KaboudarAhang", "name_native": "کبودرآهنگ"},
                            {"id": "IR-30-3005", "name": "Bahar", "name_native": "بهار"},
                            {"id": "IR-30-3006", "name": "Razan", "name_native": "رزن"},
                            {"id": "IR-30-3007", "name": "Toyserkan", "name_native": "تویسرکان"},
                            {"id": "IR-30-3008", "name": "AsadAbad", "name_native": "اسدآباد"},
                            {"id": "IR-30-3009", "name": "Famnin", "name_native": "فامنین"},
                            {"id": "IR-30-3010", "name": "Dargzin", "name_native": "درگزین"}
                        ],
                        "name_native": "همدان"
                    },
                    {
                        "id": "IR-31",
                        "name": "Yazd",
                        "cities": [
                            {"id": "IR-31-3101", "name": "Yazd", "name_native": "یزد"},
                            {"id": "IR-31-3102", "name": "Meybod", "name_native": "میبد"},
                            {"id": "IR-31-3103", "name": "Ardakan", "name_native": "اردکان"},
                            {"id": "IR-31-3104", "name": "Mehriz", "name_native": "مهریز"},
                            {"id": "IR-31-3105", "name": "Abarkouh", "name_native": "ابرکوه"},
                            {"id": "IR-31-3106", "name": "Bafgh", "name_native": "بافق"},
                            {"id": "IR-31-3107", "name": "Taft", "name_native": "تفت"},
                            {"id": "IR-31-3108", "name": "Eshkazar", "name_native": "اشکذر"},
                            {"id": "IR-31-3109", "name": "Khatam", "name_native": "خاتم"},
                            {"id": "IR-31-3110", "name": "BahAbad", "name_native": "بهاباد"},
                            {"id": "IR-31-3111", "name": "Marvast", "name_native": "مروست"},
                            {"id": "IR-31-3112", "name": "Zarach", "name_native": "زارچ"}
                        ],
                        "name_native": "یزد"
                    }
                ]
            }
        ]
    }

;
